module.exports = __webpack_public_path__ + "img/empty.00b9e06b.png";